"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserPrompt = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ModalContext_1 = require("../context/ModalContext");
const useSendPrompt_1 = require("../common/hooks/useSendPrompt");
const textUtil_1 = require("../common/textUtil");
const UserPrompt = () => {
    const context = (0, react_1.useContext)(ModalContext_1.ModalContext);
    const [prompt, setPrompt] = (0, react_1.useState)(context.initPrompt);
    const { generateNew } = (0, useSendPrompt_1.useSendPrompt)();
    const submit = () => {
        generateNew(prompt);
    };
    (0, react_1.useEffect)(() => {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        if (prompt && prompt.length > 0) {
            submit();
        }
        else {
            context.updateState({ editMode: !(context === null || context === void 0 ? void 0 : context.editMode) });
        }
    }, []);
    return ((0, jsx_runtime_1.jsx)("div", { children: context.editMode && ((0, jsx_runtime_1.jsxs)("div", { className: 'wpj-form-group', children: [(0, jsx_runtime_1.jsx)("div", { className: "row wpj-form-group", children: (0, jsx_runtime_1.jsx)("div", { className: "wpj-form-group-flex", children: (0, jsx_runtime_1.jsxs)("div", { className: "col-md-12", children: [(0, jsx_runtime_1.jsx)("label", { children: "Zad\u00E1n\u00ED" }), (0, jsx_runtime_1.jsx)("textarea", { name: "data[user_text]", className: "input-sm form-control resize-vertical", rows: 6, defaultValue: prompt, onKeyUp: (e) => {
                                        (0, textUtil_1.onKeyboardShiftEnter)(e, () => submit());
                                        (0, textUtil_1.onKeyboardEscape)(e, () => context.updateState({ editMode: false }));
                                    }, onKeyDown: textUtil_1.onKeyboardShiftEnter, onChange: (e) => setPrompt(e.target.value) })] }) }) }), (0, jsx_runtime_1.jsx)("div", { className: "d-flex gap-1", children: (0, jsx_runtime_1.jsxs)("button", { className: `btn btn-info`, disabled: context.loadingResponse, onClick: submit, children: [(0, jsx_runtime_1.jsx)("i", { className: "bi bi-stars m-r-1" }), "Pou\u017E\u00EDt zad\u00E1n\u00ED"] }) })] })) }));
};
exports.UserPrompt = UserPrompt;
